import { ACTION_EDIT } from '../../request';
import { Voter } from '../voter';

export class PageThemesVoter extends Voter {
    /**
     * @param {ACLVoter} acl ACL voter instance
     */
    constructor(acl) {
        super();
        this.acl = acl;
    }

    supports(request) {
        return request.resource === 'page-themes';
    }

    vote(request) {
        if (request.includes(ACTION_EDIT) && !this.canEdit(request)) {
            return false;
        }
    }

    /**
     * @param {AccessPermissionRequest} request
     * @returns {boolean}
     */
    canEdit(request) {
        return request.subject ? this.acl.grantsInArrayPayload(request, request.subject.colorId) : true;
    }
}
